import Vue from "vue";
import App from "./App.vue";
import { library, config as fontAwesomeConfig } from "@fortawesome/fontawesome-svg-core";
import '@fortawesome/fontawesome-svg-core/styles.css';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import store from "./store/store.js";
import directives from "./global/directives";
import router from "./router";
import "./styles/main.css";
import VueDragResize from "vue-drag-resize";
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import methods from './global/methods';
import DOMPurify from 'dompurify';

fontAwesomeConfig.autoAddCss = false;

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import {
	faChevronRight,
	faChevronLeft,
	faCheck,
	faCheckCircle,
	faTimesCircle,
	faSlidersH,
	faChevronDown,
	faExclamationCircle,
	faExclamation,
	faInfo,
	faStar,
	faTimes,
	faSearch,
	faAngleDown,
	faTrashAlt,
	faCopy,
	faFlag,
	faAngleUp,
	faGlobe,
	faTrash,
	faPlusSquare,
	faMicrophone,
	faMapMarker
} from "@fortawesome/free-solid-svg-icons";

library.add(
	faChevronRight,
	faChevronLeft,
	faCheck,
	faCheckCircle,
	faTimesCircle,
	faSlidersH,
	faChevronDown,
	faExclamationCircle,
	faExclamation,
	faInfo,
	faStar,
	faTimes,
	faSearch,
	faAngleDown,
	faAngleUp,
	faTrashAlt,
	faCopy,
	faFlag,
	faTrash,
	faGlobe,
	faPlusSquare,
	faMicrophone,
	faMapMarker
);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component("vue-drag-resize", VueDragResize);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.directive("click-outside", directives.clickOutside);

Vue.config.productionTip = false; // Disable production buildtips in the console
Vue.config.ignoredElements = [/^div-col-/]; // Allow custom elements that start with div-col-. This is used for the column property in the SR and MR questions

Vue.prototype.methods = methods;

DOMPurify.setConfig({
  ALLOWED_TAGS: [
    "b", "u", "em", "i", "img", "ul", "ol", "li", "font", "a", "p", "strong",
    "audio", "video", "br", "hr", "span", "source", "table", "thead", "tbody",
    "tfoot", "th", "tr", "td", "center", "sup", "sub", "abbr", "div",
    "h1", "h2", "h3", "h4", "h5"
  ],
  ALLOWED_ATTR: [
	"href", "name", "target", "rel", "src", "style"
  ]
});

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
	if (!node.getAttribute) return;
	
	const nodeHasTargetAttr = node.getAttribute('target');
	if (!nodeHasTargetAttr) return;

	const relValue = (node.getAttribute('rel') || '').toLowerCase();
	const hasSafeRelValue =
		relValue === 'noopener' ||
		relValue === 'noreferrer' ||
		relValue.includes('noopener') ||
		relValue.includes('noreferrer');

	if (hasSafeRelValue === false) {
		node.setAttribute('rel', 'noopener');
	}
});

new Vue({
	store,
	router,
  	provide: {  
		DOMPurify
	},
	render: (h) => h(App),
}).$mount("#app");
